"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewLayoutToggle = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Text_1 = require("office-ui-fabric-react/lib/Text");
/**
 * ViewLayoutToggle - Switch between the side-by-side ("default") and
 * graph-first builder layouts. Disabled and locked to compact below the
 * configured viewport breakpoint.
 */
exports.ViewLayoutToggle = function (_a) {
    var viewLayout = _a.viewLayout, isLocked = _a.isLocked, onChange = _a.onChange;
    return (react_1.default.createElement("div", { className: "ws-view-toggle-container" },
        react_1.default.createElement(Text_1.Text, { variant: "small", className: "ws-view-toggle-label" }, "Layout view"),
        isLocked && (react_1.default.createElement(Text_1.Text, { variant: "xSmall", className: "ws-view-toggle-helper" }, "Locked to stacked view below 1280px")),
        react_1.default.createElement("div", { className: "ws-view-toggle" },
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'DoubleColumn' }, title: "Default view - Controls on left, Graph on right", ariaLabel: "Default view layout", onClick: function () { return onChange('default'); }, disabled: isLocked, className: viewLayout === 'default'
                    ? 'ws-admin-button-hover-accent ws-view-toggle-active'
                    : 'ws-admin-button-hover-accent' }),
            react_1.default.createElement(Button_1.IconButton, { iconProps: { iconName: 'SingleColumn' }, title: "Graph-first view - Graph on top, Controls below", ariaLabel: "Graph-first view layout", onClick: function () { return onChange('graph-first'); }, disabled: isLocked, className: viewLayout === 'graph-first'
                    ? 'ws-admin-button-hover-accent ws-view-toggle-active'
                    : 'ws-admin-button-hover-accent' }))));
};
